import * as React from "react";

import { Button, ButtonGroup, H2 } from "@blueprintjs/core";
import { css } from "glamor";

import Circle from "./Circle";
import Timer from "./Timer";

interface Props {
	name: string;
	duration: number;
	startTime: number;
	nextPhase: (value: number) => void;
	previousPhase: (value: number) => void;
	canGoBack: boolean;
	dark: boolean;
}

interface State {
	durationLeft: number;
	resetTimer: number;
	timeModifier: number;
	pause: boolean;
}
const styles = {
	container: css({
		display: "flex",
		height: "100%",
	}),
	circleSide: css({
		width: "75%",
	}),
	buttonSide: css({
		width: "25%",
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-start",
	}),
	button: css({
		margin: "30px 0",
		width: "150px",
	}),
};

export default class TimerPhase extends React.Component<Props, State> {
	public state = {
		durationLeft: 0,
		resetTimer: 0,
		timeModifier: 0,
		pause: false,
	};

	public setDurationLeft = (durationLeft: number) => {
		this.setState({ durationLeft });
	};

	private togglePause = () => {
		this.setState({ pause: !this.state.pause });
	};

	public endTimerPhase = () => {
		this.props.nextPhase(this.state.durationLeft);
		this.setState({ durationLeft: 0 });
	};
	public previousPhase = () => {
		this.props.previousPhase(this.state.durationLeft);
		this.setState({ durationLeft: 0 });
	};
	private reset = () => {
		this.setState({ resetTimer: this.state.resetTimer + 1 });
	};
	private setTimeModifier(change: number) {
		this.setState({ timeModifier: this.state.timeModifier + change });
	}
	public render() {
		return (
			<div {...styles.container}>
				<div {...styles.circleSide}>
					<Timer
						duration={this.props.duration}
						onChange={this.setDurationLeft}
						startTime={this.props.startTime}
						resetTimer={this.state.resetTimer}
						timeModifier={this.state.timeModifier}
						pause={this.state.pause}
					/>
					<Circle
						radius={270}
						percentage={1 - this.state.durationLeft / this.props.duration}
						overTime={this.state.durationLeft <= 0}
						dark={this.props.dark}
					/>
					<H2>{this.props.name}</H2>
				</div>
				<div {...styles.buttonSide}>
					<Button disabled={!this.props.canGoBack} {...styles.button} onClick={this.previousPhase}>
						Previous
					</Button>
					<Button {...styles.button} onClick={this.reset}>
						Reset
					</Button>
					<Button {...styles.button} onClick={this.togglePause}>
						{this.state.pause ? "Resume" : "Pause"}
					</Button>
					<ButtonGroup {...styles.button}>
						<Button onClick={() => this.setTimeModifier(-1)}>-10 sec</Button>
						<Button onClick={() => this.setTimeModifier(1)}>+10 sec</Button>
					</ButtonGroup>
					<Button {...styles.button} onClick={this.endTimerPhase}>
						Next
					</Button>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/TimerPhase.tsx